<template>
  <error-page-content>
    <div class="error-page-wrap">
      <div v-if="errorStruct.code === '401'" class="error-page__logo">
        <img src="~@/assets/403.svg" />
      </div>

      <div v-else-if="errorStruct.status_code === '503'" class="error-page__logo">
        <img src="~@/assets/403.svg" />
      </div>

      <div v-else class="error-page__logo">
        <img src="~@/assets/400.svg" />
      </div>
      <template v-if="errorStruct">
        <styledErrorTitle>{{
          errorStruct.translations.title[($i18n || {}).locale || 'en'] || ''
        }}</styledErrorTitle>

        <div class="error-page__description">
          {{ errorStruct.translations.details[($i18n || {}).locale || 'en'] || '' }}
        </div>
      </template>
    </div>
  </error-page-content>
</template>

<script>
import StructCaller from '@/helpers/structInterface';

import styled from 'vue-styled-components';

const styledErrorTitle = styled.div`
  color: var(--on_background);
  margin-top: 10px;
  line-height: 1.25;
  font-size: 24px;
  text-align: center;
`;

const ErrorPageContent = styled.div`
  color: var(--on_background);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100% - 46px);
`;
const styledErrorDescription = styled.div`
  margin-top: 10px;
  line-height: 1.5;
  text-align: center;
`;

export default {
  name: 'ErrorContentPage',

  components: {
    ErrorPageContent,
    styledErrorTitle,
  },
  props: {
    errorData: {
      type: [Object, Error],
      default: () => {},
    },
  },
  // functional: true,
  // render(h, context) {
  //   console.log("Context", context);
  //   let element = <span>{context.children}</span>;
  //   let errorData = context.props.errorData;
  //   let errorSVG;

  //   let errorStructData = StructCaller.getStructData(
  //     "ERRORS",
  //     "code",
  //     errorData.status + ""
  //   );

  //   switch (errorStructData.status_code) {
  //     case "401" || "403":
  //       errorSVG = <img src={require(`@/assets/403.svg`)} />;
  //       break;
  //     case "404":
  //       errorSVG = <img src={require(`@/assets/404.svg`)} />;
  //       break;
  //     default:
  //       errorSVG = <img src={require(`@/assets/400.svg`)} />;
  //       break;
  //   }

  //   return (
  //     <ErrorPageContent>
  //       <div class="error-page__logo">{errorSVG}</div>
  //       <styledErrorTitle>
  //         {errorStructData.translations.title[
  //           (context.$i18n || {}).locale || "en"
  //         ] || ""}
  //       </styledErrorTitle>
  //       <styledErrorDescription>
  //         {errorStructData.translations.details[
  //           (context.$i18n || {}).locale || "en"
  //         ] || ""}
  //       </styledErrorDescription>

  //       {element}
  //     </ErrorPageContent>
  //   );
  // }

  data() {
    return {
      StructCaller,
    };
  },
  computed: {
    errorStruct() {
      if (this.errorData) {
        return this.StructCaller.getStructData('ERRORS', 'code', this.errorData.status + '');
      } else {
        /**
         * Default error struct
         */
        return this.StructCaller.getStructData('ERRORS', 'code', '400');
      }
    },
  },
};
</script>
